module.exports = function(video) {
	'use strict'
	video.directive('videoCategoriesDir',videoCategoriesDir);
	videoCategoriesDir.$inject=[];
	function videoCategoriesDir() {
		return {
			template: require('./partial/video-categories.html'),
			controller:'videoCategoriesController',
			controllerAs:'vmvc',
			link: function(scope, element, attrs, ctrl) {
				    
			}

		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/videoModule/video-categories/js/directive/videoCategoriesDirective.js
// module id = 650
// module chunks = 0